import { createRoute } from '@signal/router';
import { ACCOUNT } from './core';
/**
 * LOCAL SEARCH REPORTS
 */

export var LOCAL_SEARCH_REPORTS = createRoute(ACCOUNT, 'localSearchReports');
export var LOCAL_SEARCH_REPORT = createRoute(LOCAL_SEARCH_REPORTS, ':reportSlug');